module.exports = __webpack_public_path__ + "media/application/images/svgs/mouse-pointer-211d3879086493387e0e7c8644c518c0.svg";